import styled from 'styled-components';

export const EmptyCell = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const LoadError = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(2)};
`;
